<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        width="830px"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
          </Row>
        </div>
        <div class="wid_img">
          <div>
            <img :src="item01.photoUrl" alt="暂无图片" />
          </div>
          <div class="Introduction">
            <!-- <div class="">
              价 格: <span style="color: #1966ff"> {{ item01.money }}</span>
            </div> -->
            <div class="Introduction__p">介 绍：{{ item01.p }}</div>
            <div class="phone">
              咨询电话: <span style="color: #1966ff"> 18001306738</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
          <!-- <Button type="primary" @click="goBuyGo">立即购买</Button> -->
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "SafetyEducation",
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      VRImg: [],
      photoArr1: [
        /*智能机器人*/
        {
          photoUrl: "../../../static/img/photo/photo_robot.jpg",
          p: "服务型机器人可引领讲解、智能问询等功能，构成 “1 + N” 强劲智能接待服务能力。搭载自研Robot OS系统可根据需求进行个性化场景定制，可方便、快捷接入客户系统，已在地产、医疗、教育机构、企业、酒店等多个场景落地应用，帮助客户降本提效，助力智慧化体验升级。",
          ref: "智能机器人 教育 学习 幼教投影",
          money: "¥38000.00",
        },
        /*虚拟灭火演练系统*/
        {
          photoUrl: "../../../static/img/Buy/Electric/miehuo.png",
          p: "火灾事故频繁发生的根本原因，是由于群众所掌握的消防安全知识不高，在面对突发火灾时缺乏自救和互救能力，为了杜绝或减少火灾事件的发生，提高全民消防安全意识与能力迫在眉睫，新时代要利用好科技的优势和便利，利用AR虚拟仿真技术结合消防安全打造AR虚拟灭火互动系统，主要针对消防安全科普，利用高度可视化AR仿真模拟系统，将教育与科技有趣结合为用户带来全新的消防安全知识教育与互动。",
          ref: "虚拟灭火演练系统",
          money: "",
        },

        /*安全隐患排查*/
        {
          photoUrl: "../../../static/img/Buy/Electric/photo_anquan.jpg",
          p: "1.体验建筑工地多种场景安全隐患排查寻找（包括工地、宿舍、食堂、仓库、办公区、材料区等多种场景）2 .语音解说隐患点安全问题，对体验者进行安全教育知识点培训。",
          ref: "安全隐患排查",
          money: "￥3000.00",
        },
        /*安全标识识别系统*/
        {
          photoUrl: "../../../static/img/photo/photo_biaoshi.png",
          p: "安全标识识别系统是指一种用于识别不同安全标志的系统。这些安全标志可以告知人们某个地方或场所的安全状态，例如火灾逃生路线指示牌、紧急出口指示等。此外，该系统还可以采用语音提示等方式向使用者传达相关安全信息，提高安全意识和应急能力。",
          ref: "安全标识识别系统",
          money: "￥10000.00",
        },
        /*多人在线抢答系统*/
        {
          photoUrl: "../../../static/img/Buy/Electric/qiangda.png",
          p: "内 置 多 套 题 库 ， 竞速抢答模式支持4人进行对抗,极具趣味性； 人机画面友好亲切，动画形式通俗易懂，倒计时答题，紧张刺激；题库可按企业需求进行定制开发。",
          ref: "多人在线抢答系统",
          money: "￥35000.00",
        },
        /*机械模拟伤害体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/jixieshanghai.png",
          p: "通过安全帽撞击体验、安全鞋冲击体验，手部挤压体验，使用体验者认识到按规范使用劳保用品的重要性。",
          ref: "机械模拟伤害体验",
          money: "¥31350.00",
        },

        /*综合用电体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/yongdian.png",
          p: "通过综合用电体验，学习各开关、开关箱、各种灯具及各种电线的规格说明使用，进一步普及施工现场中安全用电知识，提高电工素质和职业道德，一切按施工现场临..",
          ref: "综合用电体验",
          money: "",
        },
        /*智能劳保用品体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/laobao.png",
          p: "通过多元化的展示手法，将专业的劳保用品知识以更加直观、生动的方式传递给公众。系统不仅关注装备的静态展示，更通过动态的视频讲解，让观众能够全方位、多角度地理解劳保用品的重要性及其在实际生产中的应用。",
          ref: "智能劳保用品体验",
          money: "",
        },

        /*在线教育考试系统*/
        {
          photoUrl: "../../../static/img/Buy/Electric/photo_jiaoyu.jpg",
          p: "建筑工地安全教育/在线教育考试系统是一种通过网络技术和多媒体教学手段，对建筑工地的安全生产标准、安全操作方法等进行培训和考核的系统。",
          ref: "建筑工地安全教育/在线教育考试系统",
          money: "￥20000.00",
        },
        /*心肺复苏急救体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/xinfei.png",
          p: "心肺复苏急救体验的主要目的是让参与者熟悉并掌握心肺复苏的基本步骤和技巧，以便在紧急情况下能够迅速、准确地实施抢救，为患者争取宝贵的抢救时间，提高抢救成功率。",
          ref: "心肺复苏急救体验",
          money: "",
        },

        /*安全教育在线考试识别系统*/
        {
          photoUrl: "../../../static/img/Buy/Electric/shibie.png",
          p: "安全教育在线考试识别系统是一种针对安全教育培训的在线考试平台，旨在通过数字化手段提高安全教育的效率和效果。 ",
          ref: "安全教育在线考试识别系统",
          money: "",
        },

        /*塔吊实操体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/taji.png",
          p: "心肺复苏急救体验的主要目的是让参与者熟悉并掌握心肺复苏的基本步骤和技巧，以便在紧急情况下能够迅速、准确地实施抢救，为患者争取宝贵的抢救时间，提高抢救成功率。",
          ref: "塔吊实操体验",
          money: "",
        },
        /*电焊实操模拟体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/hangong.png",
          p: "电焊工考核设备是实操大师系列的最新产品，本设备采用软件、数字内容、硬件集成的方式将考核、研习、训练一体化，满足企业培训多样性的需求，为焊工行业的安全保驾护航。",
          ref: "电焊实操模拟体验",
          money: "¥33250.00",
        },
        /*智能密闭空间体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/mibi.png",
          p: "考核人员在密闭空间作业时，出现突发情况的正确处理流程及方法，提高作业人员的安全意识体验过程设计科学合理，体验信息上传云端，大数据分析、评估，协助企业安全教育。",
          ref: "智能密闭空间体验",
          money: "",
        },
        /*有奖答题机*/
        {
          photoUrl: "../../../static/img/Buy/Electric/dati.png",
          p: "智能答题柜为工地工人提供了通过答题获取积分并兑换礼品的互动平台。工人只需扫描二维码即可参与答题，积累积分。管理员可以灵活自定义并上传试题，确保题目内容与工地实际需求相匹配。工人在答题后，所获得的积分可以用于在答题柜中兑换丰富的礼品，既激发了学习兴趣，又增强了安全培训的效果，促进了工地知识的普及与应用。",
          ref: "有奖答题机",
          money: "",
        },
        /*隧道逃生体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/tunnel.png",
          p: "通过模拟在隧道内施工的坍塌险情，让体验者了解到如何进行逃生与营救被困人员。通过这个逃生的演练，让体验者隧道逃生意识有所增强，对抗击突发事件的应变能力有所提高，现场演练人员能有效组织...",
          ref: "隧道逃生体验",
          money: "",
        },
        /*智能平衡木体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/balancebeam.png",
          p: "本设备采用智能启动功能，人员进入体验区体验过程中通过智能大马力风机，模拟高空环境下风力对人体行走的阻碍，增加体验的真实感与趣味性。..",
          ref: "智能平衡木体验",
          money: "",
        },
        /*四警合一模拟电话报警系统*/
        {
          photoUrl: "../../../static/img/Buy/Electric/baojing.png",
          p: "四合一模拟报警系统是一种集成了119报警、110报警、122报警、120报警四种报警为一体的模拟体验设备，旨在帮助人们掌握这四种报警流程和报警要点，提高人们的安全艺术和紧急应对能力。...",
          ref: "四警合一模拟电话报警系统",
          money: "",
        },
        /*体感式语音标识系统*/
        {
          photoUrl: "../../../static/img/Buy/BodyFeel/BodyFeel02.png",
          p: "通过标识虚拟系统，学习安全标识的作用，提高对工作安全标识的认识。系统会检测体验者肢体动作，与周边的装置或环境互动选择相应标志标识进行学习。",
          ref: "体感式语音标识系统",
          money: "¥28000.00",
        },
        // 建筑消防设施联动演示系统
        {
          photoUrl: "../../../static/img/Buy/Electric/xiaofang.png",
          p: "联动演示系统以灯光形式，展示了联动设施的运作工程及原理，包括从发生火灾开始到火灾被完全扑灭。体验者还可以通过按下手动警报按钮，实现手动触发联动设施运作。通过展示了联动设施的工作原理与使用方法。",
          ref: "建筑消防设施联动演示系统",
          money: "",
        },
        /*跨步电压+用电救助体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/jiuzhu.png",
          p: "仿真跨步电压环境，让体验者认知跨步电压带来的触电伤害，使其充分了解跨步电压的危害，并使用视频教学的方法，学习在跨步电压环境下如何正确自救的方法",
          ref: "跨步电压+用电救助体验",
          money: "",
        },
        /*健康体检仪*/
        {
          photoUrl: "../../../static/img/Buy/Electric/jiankang.jpg",
          p: " 集合智能的体重身高设备、心率设备和血压测量设备，以热敏打印的形式呈现给体验者，通过体检及时了解人员的身体健康状况;便于现场管理和调整。该设备主要由体检仪主体、13.8寸智能屏、红外线身高仪、血压检测仪、打印机、身份信息录入模块、体脂测试模块等构成。",
          ref: "健康体检仪",
          money: "",
        },

        /*低压电工实操体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/diya.png",
          p: " 通过对380V自锁电路、互锁电路、220V单相电表接线与计算方式、大功率电机的降压启动及电量计算的模拟操作，使体验人员认识到电工特种作业的安全重要性，掌握基本的操作方法及用电常识。",
          ref: "低压电工实操体验",
          money: "",
        },
        /*高处作业实操体验*/
        {
          photoUrl: "../../../static/img/Buy/Electric/gaochu.png",
          p: " 高处作业是特种作业的一种，具有一定的风险性，涉及到建筑、电力、通信、维护等多个行业。在实际操作中，高处作业的安全性和效率至关重要。通过实操体验，作业人员可以更加直观地了解高处作业的环境、设备以及操作流程，从而增强安全意识和操作技能，降低事故风险。",
          ref: "高处作业实操体验",
          money: "",
        },
      ],
    };
  },
  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.VRImg = item.VRImg;
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>

<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}
/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #ffff;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}

.wid_img {
  display: flex;
  align-items: center;
}

.wid_img img {
  width: 364px;
}

.Introduction {
  width: 364px;
  height: 263px;
  margin-left: 15px;
}

.Introduction__p {
  margin-top: -39px;
}

.buy_rule img:hover {
  animation: move 0.5s linear forwards;
}

@keyframes move {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.1);
  }
}

.phone {
  margin-top: 5%;
}
</style>


// WEBPACK FOOTER //
// src/components/Buy/SafetyEducation.vue